// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card__comfirm{max-width:910px}.alert__evaluate{display:flex;gap:16px;align-items:flex-start}.alert__evaluate .icon__alert{color:#fff;background-color:#824224;padding:6px;border-radius:8px}.alert__evaluate .icon__alert img{width:18px}", ""]);
// Exports
module.exports = exports;
